// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"dbc467bf","563":"0e59ca1c","787":"06df98d5"}[chunkId] + ".chunk.js";
};